import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { CompanyButtons } from 'pages/custom/shared/detail/CompanyButtons';
import { S_PageStyle } from 'pages/page/PageStyle';
import { Layer, Source } from 'react-map-gl';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const JobspinPage = (props: Props): JSX.Element => {
    return (
        <S_JobspinPage className={props.className}>
            <CustomMapPage
                mapId={'0007180e-83d2-4686-b822-8feb3db10b3a'}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/5400490e-64c9-464f-8529-15d8a414536e.png',
                    logoText: 'Jobspin Job and Relocation Fair Prague',
                    logoSubtext: 'Interactive map',
                    link: 'https://www.jobspin.cz/jobspin-cz-job-fair-visitors/',
                    linkText: Localization.WEBSITE
                }}
                mapChildren={
                    <>
                        <Source
                            id="polylineLayer1"
                            type="geojson"
                            data={{
                                type: 'Feature',
                                properties: {},
                                geometry: {
                                    type: 'LineString',
                                    coordinates: [
                                        [14.440274075972326, 50.09913789688366],
                                        [14.440447, 50.098525],
                                        [14.441278, 50.098642],
                                        [14.441379, 50.098579],
                                        [14.441534, 50.098533],
                                        [14.442644, 50.098568],
                                        [14.442914, 50.09856],
                                        [14.442973, 50.098513],
                                        [14.443164, 50.098408],
                                        [14.443356, 50.098428],
                                        [14.443887, 50.0984],
                                        [14.443888, 50.098627],
                                        [14.446212, 50.098544],
                                        [14.446327339991, 50.10045277702386],
                                        [14.446077488191264, 50.100458366201565],
                                        [14.446101, 50.100815],
                                        [14.446836, 50.10079],
                                        [14.447107, 50.100791],
                                        [14.448391, 50.100746],
                                        [14.44931, 50.100717],
                                        [14.449926, 50.100707],
                                        [14.449930150582816, 50.10092092438896]
                                    ]
                                }
                            }}
                        >
                            <Layer
                                id="lineLayer1"
                                type="line"
                                source="polylineLayer1"
                                paint={{
                                    'line-color': '#EE2A28',
                                    'line-width': 2.5,
                                    'line-dasharray': [2, 1.5]
                                }}
                            />
                        </Source>
                        <Source
                            id="polylineLayer2"
                            type="geojson"
                            data={{
                                type: 'Feature',
                                properties: {},
                                geometry: {
                                    type: 'LineString',
                                    coordinates: [
                                        [14.446236, 50.098967],
                                        [14.446296, 50.098966]
                                    ]
                                }
                            }}
                        >
                            <Layer
                                id="lineLayer2"
                                type="line"
                                source="polylineLayer2"
                                paint={{
                                    'line-color': '#EE2A28',
                                    'line-width': 2.5,
                                    'line-dasharray': [2, 1.5]
                                }}
                            />
                        </Source>
                    </>
                }
                controls={<CompanyButtons />}
            />
        </S_JobspinPage>
    );
};

const S_JobspinPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
